var CartEmpty, CartItems, CartSpinner, CartWidget, I18n, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('../../../core/frontend/groupon_modules/groupon');

ref = require('../../client_templates'), CartItems = ref.CartItems, CartEmpty = ref.CartEmpty, CartSpinner = ref.CartSpinner;

module.exports = CartWidget = (function() {
  function CartWidget(el) {
    var ref1, ref2;
    this.el = el;
    this.renderCartData = bind(this.renderCartData, this);
    this.onComplete = bind(this.onComplete, this);
    this.fetchCartData = bind(this.fetchCartData, this);
    this.$el = $(this.el);
    this.useCartSizeEndpoint = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.LS) != null ? (ref2 = ref1.flags) != null ? ref2.useCartSizeEndpoint : void 0 : void 0 : void 0;
    this.snickerdoodle = Cookie.get('snickerdoodle');
    if (this.$el.length) {
      this.fetch();
    }
  }

  CartWidget.prototype.fetch = function() {
    var complete, data, ref1, ref2, url;
    complete = this.onComplete;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    if (this.useCartSizeEndpoint) {
      url = ((ref1 = Groupon.endpoints) != null ? ref1.cartSize : void 0) || '/cart/size';
      this.$el.one('mouseover', this.fetchCartData);
    } else {
      url = ((ref2 = Groupon.endpoints) != null ? ref2.cart : void 0) || '/cart/widget';
    }
    return $.ajax({
      type: "GET",
      url: url,
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.fetchCartData = function() {
    var complete, data, ref1, translations;
    translations = Groupon.LS.translations.cart;
    this.$el.append(CartSpinner.render({
      translations: translations
    }));
    complete = this.renderCartData;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    return $.ajax({
      type: "GET",
      url: ((ref1 = Groupon.endpoints) != null ? ref1.cart : void 0) || '/cart/widget',
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.onComplete = function(data, textStatus, xhr) {
    var $cartFlyout, hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        if (hasCart) {
          this.showCart({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          });
        } else {
          if (!this.useCartSizeEndpoint) {
            this.showEmptyCart({
              translations: translations
            });
          }
        }
        if (Groupon.LS.hasTouch) {
          $cartFlyout = $('.cart-flyout');
          this.$el.find('.icon-goods').on('tap', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $cartFlyout.toggle();
            $('html').trigger('tap');
            if ($cartFlyout.is(':visible')) {
              return $('html').one('tap', function(e) {
                if ($(e.target).closest('#ls-header-cart-link').length === 0) {
                  return $cartFlyout.hide().attr('aria-hidden', 'true');
                }
              });
            }
          });
        }
      }
    }
    this.$el.addClass('cart-widget-shows');
    return delete window.CartWidget;
  };

  CartWidget.prototype.showCart = function(data) {
    this.renderCartLink(data);
    if (!this.useCartSizeEndpoint) {
      return this.$el.append(CartItems.render(data));
    }
  };

  CartWidget.prototype.renderCartLink = function(data) {
    var markup, quantity, quantity_value, ref1, translations;
    ref1 = data.response, quantity_value = ref1.quantity_value, quantity = ref1.quantity;
    translations = data.translations;
    markup = "<span class='cart-text'>" + translations.cart.desc + " (" + quantity + ")</span>\n<span class='cart-count'>" + quantity_value + "</span>";
    return this.$el.find('.icon-goods, a').html(markup);
  };

  CartWidget.prototype.renderCartData = function(data, textStatus, xhr) {
    var hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    this.$spinnerFlyout = this.$el.find('.cart-flyout.load-spinner');
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        this.$spinnerFlyout.remove();
        if (hasCart) {
          this.renderCartLink({
            response: response,
            translations: translations
          });
          return this.$el.append(CartItems.render({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          }));
        } else {
          return this.showEmptyCart({
            translations: translations
          });
        }
      } else {
        return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
      }
    } else {
      return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
    }
  };

  CartWidget.prototype.showEmptyCart = function(data) {
    this.$el.append(CartEmpty.render(data));
    if (this.useCartSizeEndpoint) {
      return this.$el.find('#ls-cart-link').html(data.translations.cart.cart);
    }
  };

  return CartWidget;

})();

//# sourceMappingURL=data:application/json;base64,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
